var CartEmpty, CartItems, CartSpinner, CartWidget, I18n, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('../../../core/frontend/groupon_modules/groupon');

ref = require('../../client_templates'), CartItems = ref.CartItems, CartEmpty = ref.CartEmpty, CartSpinner = ref.CartSpinner;

module.exports = CartWidget = (function() {
  function CartWidget(el) {
    var ref1, ref2;
    this.el = el;
    this.renderCartData = bind(this.renderCartData, this);
    this.onComplete = bind(this.onComplete, this);
    this.fetchCartData = bind(this.fetchCartData, this);
    this.$el = $(this.el);
    this.useCartSizeEndpoint = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.LS) != null ? (ref2 = ref1.flags) != null ? ref2.useCartSizeEndpoint : void 0 : void 0 : void 0;
    this.snickerdoodle = Cookie.get('snickerdoodle');
    if (this.$el.length) {
      this.fetch();
    }
  }

  CartWidget.prototype.fetch = function() {
    var complete, data, ref1, ref2, url;
    complete = this.onComplete;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    if (this.useCartSizeEndpoint) {
      url = ((ref1 = Groupon.endpoints) != null ? ref1.cartSize : void 0) || '/cart/size';
      this.$el.one('mouseover', this.fetchCartData);
    } else {
      url = ((ref2 = Groupon.endpoints) != null ? ref2.cart : void 0) || '/cart/widget';
    }
    return $.ajax({
      type: "GET",
      url: url,
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.fetchCartData = function() {
    var complete, data, ref1, translations;
    translations = Groupon.LS.translations.cart;
    this.$el.append(CartSpinner.render({
      translations: translations
    }));
    complete = this.renderCartData;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    return $.ajax({
      type: "GET",
      url: ((ref1 = Groupon.endpoints) != null ? ref1.cart : void 0) || '/cart/widget',
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.onComplete = function(data, textStatus, xhr) {
    var $cartFlyout, hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        if (hasCart) {
          this.showCart({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          });
        } else {
          if (!this.useCartSizeEndpoint) {
            this.showEmptyCart({
              translations: translations
            });
          }
        }
        if (Groupon.LS.hasTouch) {
          $cartFlyout = $('.cart-flyout');
          this.$el.find('.icon-goods').on('tap', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $cartFlyout.toggle();
            $('html').trigger('tap');
            if ($cartFlyout.is(':visible')) {
              return $('html').one('tap', function(e) {
                if ($(e.target).closest('#ls-header-cart-link').length === 0) {
                  return $cartFlyout.hide().attr('aria-hidden', 'true');
                }
              });
            }
          });
        }
      }
    }
    this.$el.addClass('cart-widget-shows');
    return delete window.CartWidget;
  };

  CartWidget.prototype.showCart = function(data) {
    this.renderCartLink(data);
    if (!this.useCartSizeEndpoint) {
      return this.$el.append(CartItems.render(data));
    }
  };

  CartWidget.prototype.renderCartLink = function(data) {
    var markup, quantity, quantity_value, ref1, translations;
    ref1 = data.response, quantity_value = ref1.quantity_value, quantity = ref1.quantity;
    translations = data.translations;
    markup = "<span class='cart-text'>" + translations.cart.desc + " (" + quantity + ")</span>\n<span class='cart-count'>" + quantity_value + "</span>";
    return this.$el.find('.icon-goods, a').html(markup);
  };

  CartWidget.prototype.renderCartData = function(data, textStatus, xhr) {
    var hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    this.$spinnerFlyout = this.$el.find('.cart-flyout.load-spinner');
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        this.$spinnerFlyout.remove();
        if (hasCart) {
          this.renderCartLink({
            response: response,
            translations: translations
          });
          return this.$el.append(CartItems.render({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          }));
        } else {
          return this.showEmptyCart({
            translations: translations
          });
        }
      } else {
        return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
      }
    } else {
      return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
    }
  };

  CartWidget.prototype.showEmptyCart = function(data) {
    this.$el.append(CartEmpty.render(data));
    if (this.useCartSizeEndpoint) {
      return this.$el.find('#ls-cart-link').html(data.translations.cart.cart);
    }
  };

  return CartWidget;

})();

//# sourceMappingURL=data:application/json;base64,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
